var CartEmpty, CartItems, CartSpinner, CartWidget, I18n, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18n = require('../../../node_modules/grapefruit/lib/I18n');

window.I18n = new I18n();

require('../../../core/frontend/groupon_modules/groupon');

ref = require('../../client_templates'), CartItems = ref.CartItems, CartEmpty = ref.CartEmpty, CartSpinner = ref.CartSpinner;

module.exports = CartWidget = (function() {
  function CartWidget(el) {
    var ref1, ref2;
    this.el = el;
    this.renderCartData = bind(this.renderCartData, this);
    this.onComplete = bind(this.onComplete, this);
    this.fetchCartData = bind(this.fetchCartData, this);
    this.$el = $(this.el);
    this.useCartSizeEndpoint = typeof Groupon !== "undefined" && Groupon !== null ? (ref1 = Groupon.LS) != null ? (ref2 = ref1.flags) != null ? ref2.useCartSizeEndpoint : void 0 : void 0 : void 0;
    this.snickerdoodle = Cookie.get('snickerdoodle');
    if (this.$el.length) {
      this.fetch();
    }
  }

  CartWidget.prototype.fetch = function() {
    var complete, data, ref1, ref2, url;
    complete = this.onComplete;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    if (this.useCartSizeEndpoint) {
      url = ((ref1 = Groupon.endpoints) != null ? ref1.cartSize : void 0) || '/cart/size';
      this.$el.one('mouseover', this.fetchCartData);
    } else {
      url = ((ref2 = Groupon.endpoints) != null ? ref2.cart : void 0) || '/cart/widget';
    }
    return $.ajax({
      type: "GET",
      url: url,
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.fetchCartData = function() {
    var complete, data, ref1, translations;
    translations = Groupon.LS.translations.cart;
    this.$el.append(CartSpinner.render({
      translations: translations
    }));
    complete = this.renderCartData;
    data = this.snickerdoodle ? {
      consumerId: this.snickerdoodle
    } : void 0;
    return $.ajax({
      type: "GET",
      url: ((ref1 = Groupon.endpoints) != null ? ref1.cart : void 0) || '/cart/widget',
      data: data,
      complete: complete
    });
  };

  CartWidget.prototype.onComplete = function(data, textStatus, xhr) {
    var $cartFlyout, hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        if (hasCart) {
          this.showCart({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          });
        } else {
          if (!this.useCartSizeEndpoint) {
            this.showEmptyCart({
              translations: translations
            });
          }
        }
        if (Groupon.LS.hasTouch) {
          $cartFlyout = $('.cart-flyout');
          this.$el.find('.icon-goods').on('tap', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $cartFlyout.toggle();
            $('html').trigger('tap');
            if ($cartFlyout.is(':visible')) {
              return $('html').one('tap', function(e) {
                if ($(e.target).closest('#ls-header-cart-link').length === 0) {
                  return $cartFlyout.hide().attr('aria-hidden', 'true');
                }
              });
            }
          });
        }
      }
    }
    this.$el.addClass('cart-widget-shows');
    return delete window.CartWidget;
  };

  CartWidget.prototype.showCart = function(data) {
    this.renderCartLink(data);
    if (!this.useCartSizeEndpoint) {
      return this.$el.append(CartItems.render(data));
    }
  };

  CartWidget.prototype.renderCartLink = function(data) {
    var markup, quantity, quantity_value, ref1, translations;
    ref1 = data.response, quantity_value = ref1.quantity_value, quantity = ref1.quantity;
    translations = data.translations;
    markup = "<span class='cart-text'>" + translations.cart.desc + " (" + quantity + ")</span>\n<span class='cart-count'>" + quantity_value + "</span>";
    return this.$el.find('.icon-goods, a').html(markup);
  };

  CartWidget.prototype.renderCartData = function(data, textStatus, xhr) {
    var hasCart, hasError, response, responseText, showCheckout, translations;
    responseText = data.responseText;
    translations = Groupon.LS.translations.cart;
    showCheckout = Groupon.Cart.showCheckout;
    this.$spinnerFlyout = this.$el.find('.cart-flyout.load-spinner');
    if (textStatus === 'success') {
      response = JSON.parse(responseText);
      hasError = response.hasError, hasCart = response.hasCart;
      if (!hasError) {
        this.$spinnerFlyout.remove();
        if (hasCart) {
          this.renderCartLink({
            response: response,
            translations: translations
          });
          return this.$el.append(CartItems.render({
            response: response,
            translations: translations,
            showCheckout: showCheckout
          }));
        } else {
          return this.showEmptyCart({
            translations: translations
          });
        }
      } else {
        return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
      }
    } else {
      return this.$spinnerFlyout.addClass('ls-widget-error').html(translations.cart.cart_error);
    }
  };

  CartWidget.prototype.showEmptyCart = function(data) {
    this.$el.append(CartEmpty.render(data));
    if (this.useCartSizeEndpoint) {
      return this.$el.find('#ls-cart-link').html(data.translations.cart.cart);
    }
  };

  return CartWidget;

})();

//# sourceMappingURL=data:application/json;base64,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
